<template>
    <Btn
        variant="outlined"
        color="purple-800"
        class="btn-premium premium-button-box-shadow"
    >
        <!-- forward all slots -->
        <template
            v-for="(_, slot) of $slots"
            #[slot]
        >
            <slot :name="slot" />
        </template>
    </Btn>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

/**
 * Dedicated Btn with our premium styling.
 * This button currently was only designed as being an oulined version, so other variants might not work correctly.
 * Having a gradient as the outline was tricky to accomplish and the button also only works best on a white background.
 *
 * If you notice you need this button to be transparent, you might need to adjust this one and rely on background masking and clipping instead.
 */
export default defineComponent({
    name: 'BtnPremium',
});
</script>

<style lang="scss" scoped>
/*
Applying a border with a gradient is quite challening.
Instead of having a real border, we apply the gradient as a background and put a white box on-top that is only as big as the content-box (element without border).
This lets the gradient appear like a border, but we loose the transparency effect unfortunately.
If needed, we can improve the setup and make use of masking and clipping instead.
*/
.btn-premium:not(.variant-text):not(:disabled):not(.disabled) {
    background: linear-gradient(89.98deg, #5395f6 6.63%, #8e66fb 49.82%, #cc35d9 111.61%);

    &.variant-outlined,
    &.variant-tonal {
        &::before {
            background: rgb(var(--colors-white)) !important;
            border-color: transparent !important;
            border-width: 2px;
        }

        // inverting the opacity
        &:hover::before {
            opacity: 0.95 !important;
        }
        &:active::before {
            opacity: 0.85 !important;
        }
        &.active::before {
            opacity: 0.9 !important;
        }

        // hide default border box
        :deep(.btn-container:before) {
            display: none;
        }
    }

    &.variant-outlined::before {
        background-clip: content-box !important;
    }
}

.premium-button-box-shadow {
    &:hover,
    &:active {
        box-shadow: 0 0 8px 0 rgb(var(--colors-purple-700));
    }
}
</style>
